import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import LayersIcon from "@mui/icons-material/Layers";
import { blue } from "@mui/material/colors";
import ListItemButton from "@mui/material/ListItemButton";

const layers = [
  {
    layer: "Restroom",
    description:
      "Information on restrooms such as gender designation, number of fixtures, and more.",
  },
];

const title_ = (theme) => ({
  textAlign: "center",
});

const list_ = (theme) => ({
  minWidth: 400,
});

const avatar_ = (theme) => ({
  backgroundColor: blue[100],
  color: blue[600],
});

export default function SimpleDialog({ onClose, open }) {
  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={() => handleListItemClick()} open={open} maxWidth={"lg"}>
      <DialogTitle sx={title_}>Select Layer</DialogTitle>
      <List sx={list_}>
        {layers.map(({ layer, description }) => (
          <ListItemButton
            role="listitem"
            onClick={() => handleListItemClick(layer)}
            key={layer}
          >
            <ListItemAvatar>
              <Avatar sx={avatar_}>
                <LayersIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={layer} secondary={description} />
          </ListItemButton>
        ))}
      </List>
    </Dialog>
  );
}
